module.exports = "/assets/c524935ab498a040e58ee4a109f00e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/Q6.png
// module id = 1740
// module chunks = 0